import { UserState } from "../interfaces/user-state.interface";

export const initialState: UserState = {
  users: [],
  data: null,
  openSidenav: false,
  logons: [],
  userMeInfo: null,
  accountResponse: {
    logons: [],
    company: {},
    page: {
      limit: 0,
      offset: 0,
      totalElements: 0,
      totalPages: 0,
    },
  },
  selectedLogon: {
    error: null,
  },
  selectedUserId: "",
  isLoading: false,
  showEmptyList: false,
  filterParams: {
    logon: "",
    profile: "",
    status: "",
  },
  updateUserAccount: {
    error: null,
  },
  error: null,
  myAudits: null
};
